export enum TransportInvoiceEnum {
    allDocuments = 1,
    withDifferences = 2,
    withoutDifferences = 3,
}
